import { lazy, Suspense } from "react";

import { PaymentProvider } from "@/api-v3";
import { Skeleton } from "@/components/ui/skeleton";
import { type PaymentAccountCard } from "@/features/payments/types/payment-account-cards";

import { type VisualisationHandler } from "../pages/card-details/card-details-page";

import { HighnoteCardViewer } from "./highnote-card-viewer";

// Stripe.js and react-stripe-js only ship to participants who hold a Stripe card.
const StripeCardViewer = lazy(() =>
  import("./stripe-card-viewer").then((module) => ({
    default: module.StripeCardViewer,
  }))
);

export interface CardViewerProps {
  card: PaymentAccountCard;
  isVisible: boolean;
  onRegisterHandler: (cardId: string, handler: VisualisationHandler) => void;
}

export const CardViewer = (props: CardViewerProps) => {
  if (props.card.provider === PaymentProvider.stripe) {
    return (
      <Suspense
        fallback={<Skeleton className="rounded-lg aspect-[1.55] w-full" />}
      >
        <StripeCardViewer {...props} />
      </Suspense>
    );
  }

  return <HighnoteCardViewer {...props} />;
};
